import { UPDATE_OBJECT_SELECTED } from '../_redux/pareto-ads-app-redux/action/actionTypes';
import { changeSelectedClient } from '../../shared/utils/entity';

export const updateObjectSelectedMiddleware = () => next => (action) => {
    const result = next(action);

    const { type, objectSelected } = action;
    if (UPDATE_OBJECT_SELECTED === type) {
        const entityId = objectSelected.data.id;
        const entityType = objectSelected.data.type;
        changeSelectedClient(entityId, entityType);
    }

    return result;
};
